export const COUNT_CART = "COUNT_CART";
export const GET_CARTDATA = "GET_CARTDATA";
